import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InboundEngineCallToAction() {
  return <section data-section-id="20307" id="secure-your-investment-pack" className="dark bg-background text-foreground relative w-full py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(135deg,#0A1428_0%,#1A2B4B_40%,#8C6D31_100%)] opacity-95" />

      <div className="relative z-10 container mx-auto px-4 md:px-16 flex flex-col items-center text-center">
        <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 tracking-tight">
          Join 500+ Qualified Investors Today
        </h2>

        <p className="font-sans text-slate-300 text-lg md:text-xl max-w-[800px] mb-12 leading-relaxed">
          Secure your exclusive investment pack and discover how our government-backed
          10% yield social housing projects provide long-term asset security and
          guaranteed income.
        </p>

        <Button asChild className="h-auto px-12 py-5 text-lg font-medium rounded-md bg-gradient-to-r from-[#B08D43] to-[#8C6D31] text-[#0A1428] hover:opacity-90 hover:scale-[1.02] transition-all duration-300 shadow-[0_10px_40px_-10px_rgba(176,141,67,0.4)] border-none">
          <Link to="https://10percent-yield.com/contact/" className="flex items-center gap-2">
            Get Your Investment Pack
            <ArrowRight className="w-5 h-5" />
          </Link>
        </Button>
      </div>
    </section>;
}